import { EntityRepository, Repository } from "typeorm";
import { BomDetailsLog } from "../bom-details-log.entity";

@EntityRepository(BomDetailsLog)
export class BomDetailsLogRepository extends Repository<BomDetailsLog>{


}
